import React, { useEffect, useState } from 'react';
import LogoHeader from './LogoHeader';
import TopNavButtons from './TopNavButtons';
import LearningReviewModal from './LearningReviewModal';
import IntroductionalModal from './IntroductionalModal';
import BottomMenu, {IScenario} from './BottomMenu';
import ScenarioLaunch from './ScenarioLaunch'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import './MainMenu.css'

const MainMenu = (props: any) => {
	const [scenarioLaunchShown, setScenarioLaunch] = useState<IScenario>(null);
	const [displayed, setDisplayed] = useState(true);
	const [displayedLearningReview, displayLearningReview] = useState(false);
	const [displayedIntroductionReview, displayIntroductionReview] = useState(true);

	useEffect(() => {
		$(window).resize();
	})

	return (
		<div className="in-game-ui-container modal-disable-select" >
			{!scenarioLaunchShown && 
			<div className="main-menu-container" style={{visibility: displayed ? 'visible' : 'hidden' }}>
				<LazyLoadImage
					src={'./assets/img/main_menu_bg.png'}
					alt={'The external/internal areas of a VA Medical Center'}
					afterLoad={() => setDisplayed(true)}
				/>
				<video className="background-video" width="100%" title="The external/internal areas of a VA Medical Center" autoPlay loop muted playsInline>
					<source src="./assets/video/bg-video-bc-1.mp4"
						type="video/mp4" />
				</video>
				<LogoHeader />
				<TopNavButtons updateWindow={props.updateWindow} displayLearningReview={() => displayLearningReview(true)} {...props} />
				<BottomMenu updateWindow={props.updateWindow} scenarioLaunch={setScenarioLaunch} {...props} />`
				<LearningReviewModal updateWindow={props.updateWindow} displayed={displayedLearningReview} closeLearningReview={() => displayLearningReview(false)}/>
				<IntroductionalModal updateWindow={props.updateWindow} displayed={displayedIntroductionReview} closeIntroductionReview={() => displayIntroductionReview(false)}/>
			</div>
			}
			{scenarioLaunchShown && <ScenarioLaunch updateWindow={props.updateWindow} onClose={() => setScenarioLaunch(null)} {...scenarioLaunchShown}/>}
		</div>
	);
};

export default MainMenu;
